module.exports = __webpack_public_path__ + "static/xceltoken (3)-34f2f2d19d4686bb73f60abacd2c94df.png";